import React, { useState } from "react";
import {
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { Button } from "react-admin";

interface AvatarComponentProps {
  headerTitle: string;
  photoUrl: string;
}

const useStyles = makeStyles({
  avatar: {
    width: 50,
    height: 50,
    borderRadius: "50%", // Ensure it's circular
    cursor: "pointer",
  },
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

const AvatarComponent: React.FC<AvatarComponentProps> = ({
  headerTitle,
  photoUrl,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Avatar
        alt={headerTitle}
        src={photoUrl}
        className={classes.avatar}
        onClick={handleOpenDialog}
      />

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">Profile Picture</DialogTitle>
        <DialogContent>
          <img
            src={photoUrl}
            style={{
              height: "95%",
              width: "100%",
            }}
            title={headerTitle}
            alt={headerTitle}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Close" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AvatarComponent;
